import { Link } from "react-router-dom";
import type { Category } from "@/types";
import CategoryCard from "@/components/feature/CategoryCard";

export default function CategoryGrid({ categories }: { categories: Category[] }) {
  const shown = categories.slice(0, 20);
  return (
    <section className="border-y border-accent-900 bg-accent-950">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-800 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-accent-50">
              <span className="flex h-4 w-4 items-center justify-center text-primary-300">
                <i className="ri-apps-2-line text-sm"></i>
              </span>
              Browse by category
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight text-background-50 md:text-3xl">
              Popular business categories in the region
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-accent-100 md:text-base">
              From restaurants and clinics to builders and home services — jump straight into the
              category you need.
            </p>
          </div>
          <Link
            to="/categories"
            className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors duration-200 hover:bg-primary-400 cursor-pointer"
          >
            View all categories
            <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {shown.map((c) => (
            <CategoryCard key={c.id} category={c} showImage />
          ))}
        </div>
      </div>
    </section>
  );
}